// redux/authSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: [],
};

const businessSidebarTitlesSlice = createSlice({
  name: "businessSidebarTitles",
  initialState,
  reducers: {
    setList(state, action) {
      state.list = action.payload;
    },
  },
});

export const { setList } = businessSidebarTitlesSlice.actions;

export default businessSidebarTitlesSlice.reducer;

// import { createSlice } from "@reduxjs/toolkit";
